import React from 'react'
import { useSelector } from 'react-redux'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import Paged from 'components/common/Paged'
import { getLanguage } from 'ducks/auth'
import { useTemplate } from './hooks'
import { Translate } from 'utils/translate'
import { Sections } from './Sections/Sections'

import styles from './Template.module.scss'

export const Contents = ({ isWordDoc, sections, title }) => {
  const uiLanguage = useSelector(getLanguage)

  return (
    <Translate language={uiLanguage}>
      <Box
        componentId="source-html"
        className={styles.template}
        direction="column"
      >
        {isWordDoc ? (
          <p className={styles.title}>
            {title} {t`interview template`}
          </p>
        ) : (
          <div className={styles.title}>
            {title} {t`interview template`}
          </div>
        )}
        <Sections isWordDoc={isWordDoc} sections={sections} />
      </Box>
    </Translate>
  )
}

export const Template = () => {
  const {
    state: { response, isFetching },
  } = useTemplate()

  const { sections, title } = response || {}
  const uiLanguage = useSelector(getLanguage)

  return (
    <Translate language={uiLanguage}>
      {response && !isFetching && (
        <Paged>
          <footer className={styles.footer}>
            {title} {t`interview template`}
          </footer>

          <Contents isWordDoc={false} sections={sections} title={title} />
        </Paged>
      )}
    </Translate>
  )
}
